<template>
    <div>

    <b-card ref="hinweistextCardIntern" class="green-left-border w-100" v-if="!this.isEmpty(konfigModel.texteIntern)">
        <Header ref="header" :data-id="$id('header')"
                :name="$t('hinweistexte.headerIntern')" :visible="false"/>
        <div ref="merkmal" :id="$id('merkmal-gesamt')" >
            <div id="hinweisTexteIntern">
                <ul>
                    <li v-for="(text) in konfigModel.texteIntern" :key="text.i18NName" style="color: red">
                        <span v-html="text.i18NName"/>
                        <I18NImage :i18-n-pic-id="text.i18NPictureId" :pic-title="text.i18NName" :i18-n-description="text.i18NDescription" />
                    </li>
                </ul>
            </div>
        </div>
    </b-card>


    <b-card ref="hinweistextCardExtern" class="green-left-border w-100" v-if="!this.isEmpty(konfigModel.texteExtern)">
            <Header ref="header" :data-id="$id('header')"
                    :name="$t('hinweistexte.headerExtern')" :visible="false"/>
            <div ref="merkmal" :id="$id('merkmal-gesamt')" >
                <div id="hinweisTexteExtern">
                    <ul>
                        <li v-for="(text) in konfigModel.texteExtern" :key="text.i18NName">
                            <span v-html="text.i18NName">
                            </span>
                            <I18NImage :i18-n-pic-id="text.i18NPictureId" :pic-title="text.i18NName" :i18-n-description="text.i18NDescription" />
                        </li>
                    </ul>
                </div>
            </div>
    </b-card>
    </div>
</template>

<script>
    import Header from "@/components/config-page/utils/Header";
    import isEmpty from "@/mixins/isempty";
    import I18NImage from "@/components/config-page/utils/I18NImage";

    export default {
        name: "Hinweistexte",
        components: {Header, I18NImage},
        props: ['konfigModel'],
        mixins: [isEmpty],
        watch: {
            konfigModel: {
                handler(konfigModel, oldKonfiModel) {
                    if (JSON.stringify(konfigModel.texteIntern) !== JSON.stringify(oldKonfiModel.texteIntern)) {
                        this.updateTextCard(this.$refs.hinweistextCardIntern);
                    }
                    if (JSON.stringify(konfigModel.texteExtern) !== JSON.stringify(oldKonfiModel.texteExtern)) {
                        this.updateTextCard(this.$refs.hinweistextCardExtern);
                    }
                }
            }
        },
        methods: {
            updateTextCard(card) {
                if (card) {
                    card.classList.add('mark-change');
                    setTimeout(() => {
                        card.classList.remove('mark-change');
                    }, 2000);
                }
            }
        }
    }
</script>

<style scoped>

    .card > .card-body {
        padding-bottom: 0px;
    }
</style>